import React, { useEffect, useState } from 'react';
import { dismissToast, subscribeToasts } from './toastStore';
import './Toast.css';
import Icon from './Icon';

const ICONS = {
    success: 'check-circle',
    error: 'exclamation-circle',
    info: 'info-circle',
};

/** Mounted once in App. Raise messages with toast.success() and friends from toastStore. */
const ToastHost = () => {
    const [items, setItems] = useState([]);

    useEffect(() => subscribeToasts(setItems), []);

    return (
        <div className="toast-host" aria-live="polite" aria-atomic="false">
            {items.map((item) => (
                <div
                    key={item.id}
                    className={`toast toast-${item.type}`}
                    role={item.type === 'error' ? 'alert' : 'status'}
                >
                    <Icon name={ICONS[item.type]} className="toast-icon" />
                    <span className="toast-message">{item.message}</span>
                    {item.action && (
                        <button
                            type="button"
                            className="toast-action"
                            onClick={() => {
                                item.action.onClick();
                                dismissToast(item.id);
                            }}
                        >
                            {item.action.label}
                        </button>
                    )}
                    <button
                        type="button"
                        className="toast-close"
                        aria-label="Закрыть уведомление"
                        onClick={() => dismissToast(item.id)}
                    >
                        <Icon name="times" />
                    </button>
                </div>
            ))}
        </div>
    );
};

export default ToastHost;
